import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Alert, Spinner, Tabs, Tab } from 'react-bootstrap';
import { workoutAPI } from '../services/workoutAPI';
import PersonalRecordsTable from './PersonalRecordsTable';
import ExerciseProgressChart from './ExerciseProgressChart';
import WorkoutFrequencyCalendar from './WorkoutFrequencyCalendar';
import SummaryStatsCards from './SummaryStatsCards';
import '../styles/WorkoutTracker.scss';

function Analytics() {
  // State Management
  const [activeTab, setActiveTab] = useState('overview'); // 'overview', 'records', 'progress'
  const [personalRecords, setPersonalRecords] = useState([]);
  const [completionStats, setCompletionStats] = useState([]);
  const [exercises, setExercises] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all analytics data on mount
  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  const fetchAnalyticsData = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const [records, stats, exerciseList] = await Promise.all([
        workoutAPI.fetchPersonalRecords(),
        workoutAPI.fetchCompletionStats(),
        workoutAPI.fetchExercises()
      ]);

      setPersonalRecords(records);
      setCompletionStats(stats);
      setExercises(exerciseList);
    } catch (err) {
      console.error('Error fetching analytics:', err);
      setError('Failed to load analytics data.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Loading analytics...</p>
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  return (
    <div className="analytics-dashboard">
      <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-4">
        <Tab eventKey="overview" title={<span><i className="fas fa-chart-line me-2"></i>Overview</span>}>
          <SummaryStatsCards
            personalRecords={personalRecords}
            completionStats={completionStats}
          />
          <Row className="mt-4">
            <Col lg={12}>
              <WorkoutFrequencyCalendar completionStats={completionStats} />
            </Col>
          </Row>
        </Tab>

        <Tab eventKey="records" title={<span><i className="fas fa-trophy me-2"></i>Personal Records</span>}>
          <PersonalRecordsTable
            personalRecords={personalRecords}
            onRefresh={fetchAnalyticsData}
          />
        </Tab>

        <Tab eventKey="progress" title={<span><i className="fas fa-chart-area me-2"></i>Exercise Progress</span>}>
          <ExerciseProgressChart
            exercises={exercises}
          />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Analytics;
